export class AdmissionReportSetup {
    Id: number;
    PageId: number;
    Action: string;
    Source: string;
    constructor() {
    }
}
